/** Label for city dropdowns when the same name can exist in more than one province. */
export function cityOptionLabel(city) {
  if (!city) return "";
  const title = city.title || "";
  const province = city.province?.title;
  const country = city.country?.title || city.province?.country?.title;
  if (province && country) return `${title} — ${province}, ${country}`;
  if (province) return `${title} — ${province}`;
  return title;
}
